import { Link } from 'react-router-dom';
import { ageLabel, isOverdue } from '../audit/auditFormat';

export interface NeedsActionTileProps {
  id: string;
  label: string;
  count: number;
  oldestAt: string | null;
  /** The pre-filtered list; null when the portal has no list page for this queue. */
  to: string | null;
  /** Shown under the count when there is no link (says where the work is done instead). */
  note?: string;
  now: Date;
}

/**
 * Spec 069 AC-A2 — one queue: live count (tabular figures), the age of the oldest waiting item, and a
 * red accent with the word "overdue" past 48 h (colour is never the only signal).
 */
export default function NeedsActionTile({ id, label, count, oldestAt, to, note, now }: NeedsActionTileProps) {
  const age = count > 0 ? ageLabel(oldestAt, now) : null;
  const overdue = count > 0 && isOverdue(oldestAt, now);
  const cls = `needs-action-tile${overdue ? ' needs-action-tile--overdue' : ''}${count === 0 ? ' needs-action-tile--clear' : ''}`;
  const body = (
    <>
      <span className="needs-action-tile__label">{label}</span>
      <span className="needs-action-tile__count" data-testid={`tile-count-${id}`}>{count}</span>
      <span className="needs-action-tile__age">
        {count === 0 ? 'Nothing waiting' : age ? `oldest waiting ${age}` : 'waiting'}
        {overdue && <span className="needs-action-tile__overdue"> · overdue</span>}
      </span>
      {!to && note && <span className="needs-action-tile__note">{note}</span>}
    </>
  );
  return to ? (
    <Link to={to} className={cls} data-tile={id} aria-label={`${label}: ${count}${age ? `, oldest waiting ${age}` : ''}${overdue ? ', overdue' : ''}`}>
      {body}
    </Link>
  ) : (
    <div className={`${cls} needs-action-tile--static`} data-tile={id}>{body}</div>
  );
}
